import { Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './style';
import { useStoreState } from '@models/RootStore';
import { t } from 'ttag';
import { Close } from '@icons';
import { Button, IconButton} from '@coolremote/shared';
import PropTypes from 'prop-types';
import { getSiteAddress } from '@utils/siteAddressUtil';

const PREFERED_SORT = [3, 2, 0, 4, 1];
// ['SYSTEM_ERROR', 'INDOOR_ERROR', 'NOT_CONNECTED', 'ANOMALIES', 'MAINTENANCE'];

const SiteAlertsInfo = ({ marker, goToSiteDashboard, handleClose }) => {
  const { siteAlerts, site, color, id } = marker;
  const selections = useStoreState((s) => s.selections.selections);
  const { siteId } = selections;
  const allSites = useStoreState((state) => state.sites.allSites);

  const classes = useStyles({ color });
  const eventCategoriesData = useStoreState(
    (state) => state.types.eventCategoriesData
  );

  const handleAlertCardClick = (siteId, filterKey) => {
    window.open(
      `${window.location.origin}/alerts/site/${siteId}/filterType/${filterKey}`,
      '_blank'
    );
  };

  return (
    <div className={classes.maincontainer}>
      <div className={classes.header}>
        <Typography>{site}</Typography>
        <IconButton
          disableRipple
          onClick={handleClose}
          className={classes.iconBtnStyle}
        >
          <Close color="#fff" />
        </IconButton>
      </div>
      <div className={classes.cardContent}>
        <div>
          <Typography className={classes.title}>{t`Site address`}</Typography>
          <Typography className={classes.siteAddressDetails}>
            {getSiteAddress(allSites[id])}
          </Typography>
        </div>
        <div className={classes.alertsStatusContainer}>
          <Typography className={classes.subTitle}>{t`Alerts status`}</Typography>
          <div className={classes.alertsCardsContainer}>
            {PREFERED_SORT.map((preferredKey) => {
              return (
                <div
                  className={classes.alertCard}
                  key={preferredKey}
                  onClick={() => handleAlertCardClick(id, preferredKey)}
                >
                  <div
                    className={classes.alertCounts}
                    style={{ color: eventCategoriesData[preferredKey]?.color ?? '#999' }}
                  >
                    {siteAlerts[preferredKey] || 0}
                  </div>
                  <div className={classes.alertType}>
                    {eventCategoriesData[preferredKey]?.name || 'Unknown'}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {id != siteId && (
          <div className={classes.buttonContainer}>
            <Button
              variant="outlined"
              style={{ textTransform: 'none' }}
              onClick={() => goToSiteDashboard(id)}
            >
              {t`Go to Site Dashboard`}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

SiteAlertsInfo.propTypes = {
  marker: PropTypes.object.isRequired,
  goToSiteDashboard: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
  

export default SiteAlertsInfo;
